import { z } from "zod";
export const ActivityEventType = z.enum([
    "USER_CREATED",
    "USER_LOGIN",
    "PROFILE_UPDATED",
    "ROLE_CHANGED",
    "TIER_CHANGED",
    "ACCOUNT_DEACTIVATED",
    "ACCOUNT_REACTIVATED",
    "PASSWORD_RESET",
    "COURSE_ENROLLED",
    "COURSE_UNENROLLED",
    "COURSE_COMPLETED",
    "MODULE_STARTED",
    "MODULE_COMPLETED",
    "EXERCISE_ATTEMPTED",
    "EXERCISE_COMPLETED",
    "ADMIN_NOTE_ADDED",
    "CURATOR_ASSIGNED",
    "INVITE_EMAIL_SENT",
    "INVITE_EMAIL_OPENED",
]);
export const ActivityLogSchema = z.object({
    id: z.number(),
    user_uid: z.string(),
    event_type: ActivityEventType,
    description: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional(),
    actor_uid: z.string().optional(),
    actor_name: z.string().optional(),
    created_at: z.string(),
});
export const ActivityLogFiltersSchema = z.object({
    event_type: ActivityEventType.optional(),
    from_date: z.string().optional(),
    to_date: z.string().optional(),
});
